import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  logo: {
    margin: theme.spacing(1),
  },

  main: {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),
      alignItems: 'center',
    },
  },

  mainError: {
    minHeight: '100vh',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    boxSizing: 'border-box',
    textAlign: 'center',

    '& > div': {
      maxWidth: 600,
      width: '100%',
    },

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },

  title: {
    fontSize: 25,
    color: 'black',
    fontWeight: 600,
    textAlign: 'center',
    marginBottom: theme.spacing(3),

    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
      marginBottom: theme.spacing(2.5),
    },

    [theme.breakpoints.down('xs')]: {
      fontSize: 20,
    },
  },

  paper: {
    width: '100%',
    boxSizing: 'border-box',

    marginTop: theme.spacing(2),

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',

    padding: theme.spacing(4),

    borderRadius: 8,

    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(1),
      padding: theme.spacing(3),
    },

    [theme.breakpoints.down('xs')]: {
      marginTop: 0,
      padding: theme.spacing(2),
      borderRadius: 6,
    },
  },

  formControl: {
    width: '100%',
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
  },

  submitBtn: {
    width: '100%',
    minHeight: 44,

    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),

    boxShadow: 'none',
    textTransform: 'none',

    lineHeight: '36px',
    padding: `0 ${theme.spacing(3)}px`,

    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(3),
    },

    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(2.5),
      padding: `0 ${theme.spacing(2)}px`,
    },
  },
}));
